// extracted by mini-css-extract-plugin
export default {"cls1":"OverlappingAvatars-cls1___4dc1868094fb5049aab","cls2":"OverlappingAvatars-cls2___44b412b63515a749400 OverlappingAvatars-cls1___4dc1868094fb5049aab"};